import { useState } from "react";
import { ChevronDown, Download } from "lucide-react";

const STEPS = {
  iphone: {
    label: "iPhone",
    groups: [
      ["Using Live Text (Photos app)", ["Tap \"Save QR code\" above, or take a screenshot of the QR code.", "Open the Photos app and view the saved image or screenshot.", "Tap and hold directly on the QR code inside the image.", "Tap the pop-up link or select Open in Safari / WOI."]],
      ["Using the screenshot shortcut", ["Take a screenshot of the QR code.", "Tap the small QR code badge that appears in the bottom-right corner of the screenshot preview.", "Tap the link to open it and complete your WOI payment."]],
    ],
  },
  android: {
    label: "Android",
    groups: [
      ["Using Circle to Search", ["Keep this screen with the QR code open.", "Press and hold your Home button or the navigation bar at the bottom of your screen.", "Circle the QR code with your finger to scan it and show the link."]],
      ["Using Google Lens / Google Photos", ["Tap \"Save QR code\" above, or take a screenshot of the QR code.", "Open the image in Google Photos or your gallery.", "Tap the Lens icon at the bottom of the screen.", "Tap the link that pops up to complete your WOI payment."]],
    ],
  },
};

export function QrHelp({ src }) {
  const [open, setOpen] = useState(false);
  const [os, setOs] = useState(/android/i.test(navigator.userAgent) ? "android" : "iphone");
  return (
    <div className="mt-3 text-left" data-testid="qr-help">
      <a href={src} download="adventure-rock-woi-qr.png" className="flex items-center justify-center gap-2 w-full rounded-full border-2 border-turquoise text-navy font-bold text-sm py-2" data-testid="qr-save-btn"><Download className="w-4 h-4" />Save QR code to my phone</a>
      <button type="button" onClick={() => setOpen(!open)} className="mt-2 w-full flex items-center justify-between text-sm font-bold text-navy py-2" data-testid="qr-help-toggle">
        Paying on this phone? How to scan the QR code <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="rounded-xl bg-white border border-slate-200 p-3 text-[13px] text-slate-700" data-testid="qr-help-steps">
          <div className="grid grid-cols-2 gap-1 mb-3 bg-slate-100 rounded-full p-1">
            {Object.entries(STEPS).map(([k, v]) => (
              <button key={k} type="button" onClick={() => setOs(k)} className={`rounded-full py-1.5 text-xs font-bold ${os === k ? "bg-navy text-white" : "text-slate-500"}`} data-testid={`qr-help-${k}`}>{v.label}</button>))}
          </div>
          {STEPS[os].groups.map(([title, steps]) => (
            <div key={title} className="mb-3 last:mb-0">
              <p className="font-bold text-navy mb-1">{title}</p>
              <ol className="list-decimal pl-5 space-y-1">{steps.map((s) => <li key={s}>{s}</li>)}</ol>
            </div>))}
          <p className="text-xs text-slate-500 mt-2">Paying from another phone? Just open its camera and point it at the code. Remember to add your payment reference, then tap "I have paid".</p>
        </div>)}
    </div>
  );
}
